module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAAAA3NCSVQICAjb4U/gAAAABmJLR0QAAACXAKdJrSNBAAABIUlEQVRYhWNkmL6cYTABpoF2ADoYdRAhMOogQmDUQYTAqIMIgUHnIBZqGbTNy16Km3PTg6d1py9TYg7VQkhLkE9fWECOh4tCc6gWQnufvhTn5Ljw5j2F5jCO1vYEwKBzENXS0FRbY3UBvhMv39ScoiiXUc1B5mLCxqJCP/78pdCcQRdlow4iBEYdRAiMOogQGHUQITDqIEJg1EGEANUcxM3KwsDA8PPvPwrNoY6DpLg4lfh4GBgY7n3+QqFRlLaHUjWVVfh5ghRl2ZiY/jMwrLzzaIAdFK+uaC0hwsDA8J+BoeLExTOv3w2wg6ZduX34+as3P35uffjsxofPFJpGBQctu/OQ4Q7lzkCA4ZvtqQVGHUQIjDqIEBh1ECEw6iBCAAAJkDrYwe0P7AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/picture2.jpg
// module id = 368
// module chunks = 0